import { type GetStaticProps } from "next";
import Footer from "~/components/Footer";
import PodHead from "~/components/Head";
import Navbar from "~/components/Navbar";
import { api } from "~/utils/api";
import Podcasts from "~/components/Podcast/Podcasts";
import { type DehydratedState } from "@tanstack/react-query";
import {
  dehydrateState,
  serversideHelpers,
} from "~/utils/serverside_helper.util";
import AppConstants from "~/constants/app.constants";

export const getStaticProps: GetStaticProps<{
  trpcState: DehydratedState;
}> = async () => {
  await serversideHelpers.content.getEpisodes.prefetch({});

  return {
    props: {
      trpcState: dehydrateState(serversideHelpers.dehydrate),
    },
    revalidate: AppConstants.DEFAULT_REVALIDATE_IN_SECONDS,
  };
};

export default function EpisodesPage() {
  const { data: podcasts } = api.content.getEpisodes.useQuery(
    {},
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  return (
    <>
      <PodHead title="Episodes" />
      <main className="flex min-h-screen flex-col items-center justify-between bg-gradient-to-t from-orange-400 via-orange-300 to-indigo-500">
        <div className="fixed left-0 right-0 top-0 z-10 w-full">
          <Navbar showLogo />
        </div>
        <div className="h-full w-full flex-1 bg-base-100/50 pb-16 pt-24 backdrop-blur-sm">
          {podcasts && <Podcasts podcasts={podcasts} full />}
        </div>
        <div className="bottom-0 left-0 right-0 z-10 w-full transition-opacity">
          <Footer />
        </div>
      </main>
    </>
  );
}
